import BrandingUpgradeBanner from 'FormsUI/components/common/BrandingUpgradeBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MAX_ROWS_ABOVE_PQL_ROW } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const PqlRow = ({
  page,
  rowIndex
}) => {
  const isFirstPage = page === 0;
  const isSecondRow = rowIndex === MAX_ROWS_ABOVE_PQL_ROW;
  const pqlRow = BrandingUpgradeBanner({
    upgradeKey: 'forms-remove-branding-index',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.frameworkTable.pqlMessage"
    })
  });
  const showPqlRow = pqlRow !== null && isFirstPage && isSecondRow;
  return showPqlRow ? pqlRow : null;
};
export default PqlRow;